/** 合同状态 */
export enum ContractStatus {
    /** 有效 */
    VALID,

    /** 中止 */
    SUSPENDED,

    /** 终止 */
    TERMINATED,
}

/** https://km.sankuai.com/page/192864827#id-7、服务商查询合同信息（服务商后台新增接口） */
export interface ContractInfo {
    providerId: number;
    contractId: string;
    startTime: number;
    endTime: number;
    suspendTime: number;
    status: ContractStatus;
}
